import store from '@/store/index';
import config from '@/utils/im/config.js';
import {
  Local
} from '@/utils/local.js';
import {
  getWebsiteConfig
} from "@/services/systemSetting.js";
import { saveCollectErrorMessage, saveRequestLog } from '@/services/chat.js';
import { encryptAES, EncryptRSA } from '@/utils/encrypt.js';
import { setCookie, getCookie, removeCookie, getBrowserFinger } from "@/utils/md5";
import {apiSendEvent, apiUpdateSiteId} from "../../../services/chat";
import {iframeMessageSend} from "../../../utils/im/validate";
import YunduoAdapter from '@/utils/yunduoAdapter.js';

export default {
  //获取取到配置信息
  fetchChatConfig({
    state,
    commit,
    dispatch
  }) {
    // 取到配置信息的type列表值（值是数组或者对象，需要转换一下）
    let chatConfigTypeList = [3, 8, 11, 13, 14, 16, 18, 19, 22, 28, 36, 38, 40, 50];
    let params = {
      childChannelId: state.childChannelId,
      companyId: state.companyId
    }
    getWebsiteConfig(params).then((res) => {
      if (res.code == 1 && res.data) {
        let resData = res.data;
        const obj = {};
        resData.forEach((item) => {
          if (item.id) {
            if (chatConfigTypeList.includes(item.type)) {
              item.value = item.type === 50 ? item.value : JSON.parse(item.value);
            }
            obj[item.type] = item;
          }
        });
        commit('SET_CHAT_CONFIG', obj);
      }
    }).catch(error => {
      // console.log('getWebsiteConfig---error', error.response);
      if(error.response) {
        const obj = {
          from: 'storeActions',
          api: {
            url: '/ai-customer-service/cs/visitor/config/all/',
            params
          },
          error: error.response.data
        }
        dispatch('collectErrorMessage', obj);
      }
    });
  },
  async initChatNimSdk({
    state,
    commit,
    dispatch
  }, {
    userInfo,
    cb
  }) {
    let account = userInfo.userId;
    let token = userInfo.netEaseToken;
    console.log(`访客${account}的用户信息`, userInfo);
    console.log(`config.appkey`, config.appkey);
    const useYunduoAdapter = state.visitSign && state.visitSign.includes('atb');
    // const useYunduoAdapter = true;
    const NIM_TAR=useYunduoAdapter ? YunduoAdapter : NIM;
    state.nim = await NIM_TAR.getInstance({
      // debug: true,
      appKey: config.appkey,
      account: account,
      token: token,
      db: config.useDb,
      syncSessionUnread: true,
      needReconnect: true,

      // 传入初始化参数
      companyId: state.companyId,
      childChannelId: state.childChannelId,
      groupConversationId: state.groupConversationId,
      visitSign: state.visitSign,
      visitName: state.visitName,
      onconnect: (obj) => {
        console.log(`访客${account}建立链接成功`, obj);
        // state.nim.setOptions({
        //   account: account,
        //   appKey: config.appkey,
        //   token: token // 建议token生成逻辑在客户的服务器侧完成，以免AppSecret泄露。
        // })
        dispatch('collectRequestLog', {
          step: 'six',
          result: 'success,chat'
        })
        window.parent && window.parent.postMessage && window.parent.postMessage(JSON.stringify({
          type: 'vistitInfoInitFinishCb',
          payload: true
        }), '*');
        cb && cb();
        dispatch('getHistoryMsgs');
      },
      onwillreconnect: (obj) => {
        console.log(`访客${account}即将重连`, obj, new Date().toTimeString());
        let onlyKey = `${state.childChannelId}_${state.groupConversationId}`
        let visitorConversationIdKey = `visitorConversationId_${onlyKey}`;
        let conversationId = getCookie(visitorConversationIdKey)
        if (!conversationId && state.netNimStatus === 'connect') {
          // 没有会话ID 销毁网易云信长链接
          // state.nim.logout()
          // state.nim.disconnect()
          state.nim.destroy({
            done: (e) => {
              state.nim = null
              console.log('网易销毁了吗', e)
              commit('UPDATE_NET_NIM_STATUS', 'done');
            }
          })
        }
      },
      ondisconnect: (error) => {
        console.log(`访客${account}断开连接`, error);
        let onlyKey = `${state.childChannelId}_${state.groupConversationId}`
        let visitorConversationIdKey = `visitorConversationId_${onlyKey}`;
        let conversationId = getCookie(visitorConversationIdKey)
        if (!conversationId && state.netNimStatus === 'connect' && state.nim) {
          // 没有会话ID 销毁网易云信长链接
          state.nim.destroy({
            done: () => {
              console.log('销毁')
              state.nim = null
              commit('UPDATE_NET_NIM_STATUS', 'done');
            }
          })
        }
      },
      onerror: (error, obj) => {
        console.log(`访客${account}发生错误`, error, obj);
        dispatch('collectRequestLog', {
          step: 'six',
          result: 'error' + error
        })
      },
      onmyinfo: (user) => {
        console.log(`访客${account}的名片信息`, user);
        state.myInfo = user;
        let customs = user.custom ? JSON.parse(user.custom) : {};
        if (!customs.webtype) {
          state.nim.updateMyInfo({
            ...user,
            custom: JSON.stringify({
              ...customs,
              webtype: state.webtype
            }),
            done: (error, user) => {
              if (!error) {
                console.log("访客用户更新成功");
              }
            },
          });
        }
      },
      onupdatemyinfo: (user) => {
        console.log(`访客${account}的名片信息更新了`, user);
        state.myInfo = NIM.util.merge(state.myInfo, user);
        dispatch('updateLocalVisitorInfo', user);
      },
      onsessions: (sessions) => {
        console.log(`访客${account}的会话列表`, sessions);
        dispatch('updateSessionsAccount', sessions);
        store.commit('UPDATE_SESSIONS', sessions);
      },
      onupdatesession: (session) => {
        console.log(`onupdatesession  ===> 访客${account}的某个会话列表更新`, session);
        dispatch('updateSessionsAccount', [session]);
        store.commit('UPDATE_SESSIONS', [session]);
      },
      onmsg: (msg) => {
        console.log(`onmsg ===> 访客${account}的收到消息`, msg);
        dispatch('onMsg', msg);
      },
      onsysmsg: (sysMsg) => {
        console.log('收到系统通知', sysMsg)
        if (sysMsg.type == 'deleteMsg') {
          store.commit('ON_REVOCATE_MSG', sysMsg);
        }
      },
      onsyncdone: () => {
        // 当上面各个同步完成后, 会调用此回调
        // SDK保证在onsyncdone调用的时候上面的同步肯定完成了, 但是不保证各个同步回调的顺序
        // 此时可以渲染自己的UI界面
        console.log(`访客${account}同步信息完成---state`, state);
        dispatch('getHistoryMsgs');
      },
    });
  },
  // 如果会话对象不是好友，需要更新好友名片
  updateSessionsAccount({
    state,
    commit,
    dispatch
  }, sessions) {
    let accountsNeedSearch = [];
    sessions.forEach(item => {
      if (item.scene === 'p2p') {
        if (!state.sessionUserMap[item.to]) {
          accountsNeedSearch.push(item.to);
        }
      }
    });
    if (accountsNeedSearch.length > 0) {
      let nim = state.nim;
      nim.getUsers({
        accounts: accountsNeedSearch,
        sync: true,
        done: function searchUsersDone(error, users) {
          if (error) {
            console.log('updateSessionsAccount---error', error);
            return;
          }
          console.log('updateSessionsAccount---users', users);
          commit('UPDATE_USER_INFO', users);
        }
      });
    }
  },
  // 设置当前会话id
  setCurrSessionId({
    state,
    commit,
    dispatch
  }, currSessionId) {
    commit('UPDATE_CURR_SESSION_ID', currSessionId);
    if (!state.currSessionMsgs.length) {
      dispatch('getHistoryMsgs');
    }
  },
  // 将会话列表的第一次消息标识存在LocalStorage
  setCurrSessionFirstFlag({
    state,
    commit,
    dispatch
  }, firstFlag) {
    commit('UPDATE_VISITOR_FIRST_FLAG_MAP', firstFlag);
  },
  // 获取聊天记录
  getHistoryMsgs({
    state,
    commit,
    dispatch
  }) {
    const nim = state.nim;
    if (nim && state.currSessionId) {
      let options = {
        scene: 'p2p',
        to: state.currSessionId.replace(/^p2p-/, ''),
        conversationId: state.currSessionConversationId,
        reverse: false,
        asc: true,
        limit: 20,
        done: function getHistoryMsgsDone(error, obj) {
          console.log('获取到聊天记录obj', obj);
          if (obj.msgs) {
            if (obj.msgs.length === 0) {
              // dispatch('setColleagueNoMoreHistoryMsgs', true);
            } else {
              const newMsg = obj.msgs.map((item) => {
                return {
                  ...item,
                  isHistory_custom: true
                }
              })
              commit('UPDATE_CURR_SESSION_MSGS', {
                type: 'concat',
                msgs: newMsg,
              });
            }
          }
          // 消息加载完成后恢复滚动功能
          commit('SET_NOT_SCROLL', false);
          // dispatch('setColleagueLoadMoreLoading', false);
        }
      }
      if (state.currSessionLastMsg) {
        options = Object.assign(options, {
          lastMsgId: state.currSessionLastMsg.idServer,
          endTime: state.currSessionLastMsg.time,
        });
      }
      // dispatch('setColleagueLoadMoreLoading', true);
      nim.getHistoryMsgs(options);
    }
  },
  // 更新本地访客信息
  updateLocalVisitorInfo({
    state,
    commit,
    dispatch
  }, user) {
    let visitorKey = `ocr_visitorInfo_${state.childChannelId}`;
    let visitorInfo = getCookie(visitorKey);
    if (visitorInfo) {
      setCookie(visitorKey, visitorInfo);
    }
  },
  onMsg({
    state,
    commit,
    dispatch
  }, msg) {
    console.log('访客收到消息', msg.scene, msg.type, msg);
    commit('PUT_MSG', msg);
    // 考虑客服被转接给其他客服还能继续聊天的情况，目前不判断是哪个客服的，当前收到的消息都先展示出来
    // if (msg.sessionId === this.currSessionId) {
    commit('UPDATE_CURR_SESSION_MSGS', {
      type: 'put',
      msg
    });
    // }
    dispatch('handleNewMsg', msg);
  },
  setInitConversationId({
    state,
    commit,
    dispatch
  }, conversationId) {
    if (!conversationId) return;
    let onlyKey = `${state.childChannelId}_${state.groupConversationId}`
    let visitorConversationIdKey = `visitorConversationId_${onlyKey}`;
    setCookie(visitorConversationIdKey, conversationId, 7)
    commit('IS_CONNECT_SOCKET', {
      id: conversationId,
      flag: true
    });
    commit('UPDATE_CONVERSATION_ID', conversationId);
    if (state.reconnectFirstMsg) {
      dispatch('sendFirstMsg', state.reconnectFirstMsg);
    }
    commit('UPDATE_CURR_SESSION_RECONNECT', false);
  },
  handleNewMsg({
    state,
    commit,
    dispatch
  }, msg) {
    let onlyKey = `${state.childChannelId}_${state.groupConversationId}`
    let visitorConversationIdKey = `visitorConversationId_${onlyKey}`;
    // let visitorFirstFlagMapKey = `visitorFirstFlagMap_${onlyKey}`
    // let visitorFirstFlagMap = Local.get(visitorFirstFlagMapKey);

    // let currSessionFirstFlag = true;
    // if (visitorFirstFlagMap) {
    //   visitorFirstFlagMap = JSON.parse(visitorFirstFlagMap);
    //   console.log('访客发送消息之前---visitorFirstFlagMap', visitorFirstFlagMap);
    //
    //   if (visitorFirstFlagMap[state.currSessionId]) {
    //     currSessionFirstFlag = visitorFirstFlagMap[state.currSessionId];
    //   } else {
    //     currSessionFirstFlag = true;
    //   }
    // }
    if (msg.type == 'custom') {
      let custom = msg.custom && JSON.parse(msg.custom);
      let content = msg.content && JSON.parse(msg.content);
      let msgData = content.msg;
      switch (custom.type) {
        //建立会话（将conversationId缓存到浏览器的session）
        case 1:
          if (msg.flow === 'in' && msgData.conversationId) {
            dispatch('setInitConversationId', msgData.conversationId);
          }
          break;
        //会话结束（清空缓存的conversationId）
        case 3:
          removeCookie(visitorConversationIdKey);
          // Local.remove(visitorFirstFlagMapKey);

          commit('IS_CONNECT_SOCKET', {
            id: '',
            flag: false
          });

          console.log('会话结束清空conversationId，需要告诉父页面');
          commit('UPDATE_CURR_SESSION_ID', '');
          commit('UPDATE_CONVERSATION_ID', '');
          commit('UPDATE_CURR_SESSION_RECONNECT', true);
          commit('UPDATE_VISITOR_FIRST_FLAG_MAP', true);
          commit('SET_CUSTOMER_SERVICE_INPUT_STATUS', false);
          break;
        // 转接（如果是其他客服转接过来的消息，需要做一些处理）
        case 7:
          let newCustomerServiceId = msgData.result && msgData.result.userId;
          if (newCustomerServiceId) {
            dispatch('updateCustomerServiceId', newCustomerServiceId);
          }
          break;
        // 客服介入机器人与访客的会话，和转接逻辑一样，result字段返回的值有点区别
        // (content:{"msg":{"result":23564,"text":"客服-小小客服介入会话"}})
        case 12:
          if (msgData.result) {
            dispatch('updateCustomerServiceId', msgData.result);
          }
          // 检查是否包含conversationId，如果有则更新
          if (msgData.conversationId) {
            dispatch('setInitConversationId', msgData.conversationId);
          } else if (msg.conversationId) {
            // 从消息对象中直接获取conversationId（云朵长连接的情况）
            dispatch('setInitConversationId', msg.conversationId);
          }
          break;
        case 13:
          if (msgData.text === '识别到手机号') {
            console.log('准备调用百度方法', window.parent)
            window.parent && window.parent.postMessage && window.parent.postMessage(JSON.stringify({
              type: 'onSendBaiduMessage',
              payload: {
                type: 3
              }
            }), '*');
          }
          if (msgData.text === '三句话回传') {
            console.log('准备调用广点通方法', window.parent)
            window.parent && window.parent.postMessage && window.parent.postMessage(JSON.stringify({
              type: 'onSendGDTMessage',
              payload: {
                type: 'CONSULT'
              }
            }), '*');
          }
          if (msgData.text === '访客回复识别到添加微信') {
            window.parent && window.parent.postMessage && window.parent.postMessage(JSON.stringify({
              type: 'onSendBaiduMessage',
              payload: {
                type: 35 // 百度回传复制微信 code 35
              }
            }), '*');
          }
          break;
        default:
          break;
      }

      // 收到系统普通文本展示消息时不再展示正在输入的状态
      if ((custom.type == 2 || custom.type == 8 || custom.type == 10) && msg.flow === 'in') {
        commit('SET_CUSTOMER_SERVICE_INPUT_STATUS', false);
      }
    } else {
      if (msg.status === 'success' && msg.flow === 'out') {
        // 如果第一条消息发送成功，将firstFlag置为false
        // console.log('发送了第一条消息---currSessionFirstFlag', currSessionFirstFlag);
        // if (currSessionFirstFlag) {
        //   if (visitorFirstFlagMap && visitorFirstFlagMap[state.currSessionId]) {
        //     visitorFirstFlagMap[state.currSessionId] = false;
        //   }
        //   commit('UPDATE_VISITOR_FIRST_FLAG_MAP', false);
        //   console.log('第一条发送成功后置为false---visitorFirstFlagMap', visitorFirstFlagMap);
        // }
        // 这里解决的是打开多个tab时会话结束后某个tab页面的会话不能发消息的问题
        if (!state.customerServiceId) {
          // sessionStorage.setItem('customerServiceId_' + state.childChannelId, msg.to)
          commit('UPDATE_CUSTOMER_SERVICE_ID', msg.to);
          dispatch('setCurrSessionId', `p2p-${msg.to}`);
        }
      }

      // 如果收到客服发送的消息并且访客的自定义字段responseTag是已超时，将其置空
      if (msg.flow === 'in') {
        // let user = state.myInfo;
        // let customs = user.custom ? JSON.parse(user.custom) : {};
        // if (customs.responseTag && (customs.responseTag == '已超时' || customs.responseTag == '老访客' || customs.responseTag == '新访客')) {
        //   dispatch('updateMyInfoCustomResponseTag', msg);
        // }

        // 收到客服消息时不再展示正在输入的状态
        commit('SET_CUSTOMER_SERVICE_INPUT_STATUS', false);
      }
    }
  },
  // 发送普通消息
  sendTextMsg({
    state,
    commit,
    dispatch
  }, obj) {
    console.log('访客要发送的消息参数', obj);
    const nim = state.nim
    obj = obj || {}
    let type = obj.type || ''
    switch (type) {
      case 'text':
        // 来源于场景机器人测试
        console.log(state.sourceType)
        const sourceType = state.sourceType
        if (sourceType && sourceType == 1){
          const custom = JSON.parse(obj.custom)
          custom.companyId = 0
          obj.custom = JSON.stringify(custom)
        }
        console.log('处理之后的数据', obj)
        nim.sendText({
          scene: obj.scene,
          to: obj.to,
          text: obj.text,
          custom: obj.custom,
          done: (error, msg) => {
            dispatch('onSendMsgDone', {
              error,
              msg,
              needDelete: obj.needDelete || false,
              beforeSendObj: obj,
            });
          },
          needMsgReceipt: obj.needMsgReceipt || false
        });
        break
      default:
        break;
    }
  },
  // 发送文件消息
  sendFileMsg({
    state,
    commit,
    dispatch
  }, obj) {
    console.log('访客发送文件消息---obj', obj)
    const nim = state.nim
    let {
      type,
      fileInput
    } = obj;
    if (!type && fileInput) {
      type = 'file'
      if (/\.(png|jpg|bmp|jpeg|gif)$/i.test(fileInput.value)) {
        type = 'image'
      } else if (/\.(mov|mp4|ogg|webm)$/i.test(fileInput.value)) {
        type = 'video'
      } else if (/\.(mp3)$/i.test(fileInput.value)) {
        type = 'audio'
      }
    }

    const data = Object.assign({
      type,
      uploadprogress: function (data) {
        // console.log(data.percentageText)
      },
      uploaderror: function () {
        fileInput.value = ''
        console && console.log('上传失败')
      },
      uploaddone: function (error, file) {
        fileInput.value = ''
        // console.log(error);
        // console.log(file);
      },
      beforesend: function (msg) {
        // console && console.log('正在发送消息, id=', msg);
      },
      done: function (error, msg) {
        dispatch('onSendMsgDone', {
          error,
          msg,
          needDelete: obj.needDelete || false,
          beforeSendObj: obj,
        });
      }
    }, obj)
    nim.sendFile(data)
  },
  onSendMsgDone({
    state,
    commit,
    dispatch
  }, obj) {
    let {
      error,
      msg,
      beforeSendObj
    } = obj;
    if (error) {
      console.log('发送消息失败', error, beforeSendObj);
      // 没有自定义字段：消息错误提示code：20002
      // 有自定义字段，没有会话id：消息错误提示code：20004
      // 有自定义字段，会话结束：消息错误提示code：20006
      // 敏感词：20008：不能发；20010：需要提醒（访客端没有限制敏感词）
      if (error.code == 20006) {
        // 当前会话已结束，请重新建立会话
        dispatch('updateCurrSessionReConnect', true);

        // 重新建立连接发送的第一条假消息需要value字段
        msg.value = (msg.type == 'text') ? beforeSendObj.text : beforeSendObj.fileInput;
        commit('SET_SEND_FAIL_MSG_OBJ', {
          errorCode: 20006,
          msg,
        });
      }
      return;
    }

    commit('SET_RECONNECT_FIRST_MSG', null);
    commit('SET_SEND_FAIL_MSG_OBJ', null);
    // 触发重新建立会话的真正发送成功的第一条消息不再展示
    // if(!obj.needDelete) { //假消息不显展示了，所以不用再判断obj.needDelete，走到这里的都是发送成功的消息
    dispatch('onMsg', msg);

    window.parent && window.parent.postMessage && window.parent.postMessage(JSON.stringify({
      type: 'visit_onSendMsgDone',
      payload: true
    }), '*')

    // 访客发送成功消息时显示客服正在输入的状态（过2秒后显示）
    setTimeout(() => {
      commit('SET_CUSTOMER_SERVICE_INPUT_STATUS', true);
    }, 1000);
    // }

    // 访超过10秒没有收到消息不再显示客服正在输入的状态
    setTimeout(() => {
      if (state.customerServiceInputStatus) {
        commit('SET_CUSTOMER_SERVICE_INPUT_STATUS', false);
      }
    }, 11000);
  },
  // 更新转接的客服id
  updateCustomerServiceId({
    state,
    commit,
    dispatch
  }, newCustomerServiceId) {
    let currSessionId = `p2p-${newCustomerServiceId}`;
    dispatch('setCurrSessionId', currSessionId);
    commit('UPDATE_VISITOR_FIRST_FLAG_MAP', true);
    // sessionStorage.setItem('customerServiceId_' + state.childChannelId, newCustomerServiceId);
    commit('UPDATE_CUSTOMER_SERVICE_ID', newCustomerServiceId);
    // 切换会话时需要重新获取conversationId
    let onlyKey = `${state.childChannelId}_${state.groupConversationId}`;
    let conversationId = getCookie(`visitorConversationId_${onlyKey}`);
    if (conversationId) {
      dispatch('updateConversationId', conversationId);
    }
  },
  // 更新转人工转接的客服id
  updateArtificialCustomerServiceId({
    state,
    commit,
    dispatch
  }, newCustomerServiceId) {
    let currSessionId = `p2p-${newCustomerServiceId}`;
    commit('UPDATE_CURR_SESSION_ID', currSessionId);
    commit('UPDATE_VISITOR_FIRST_FLAG_MAP', true);
    // sessionStorage.setItem('customerServiceId_' + state.childChannelId, newCustomerServiceId);
    commit('UPDATE_CUSTOMER_SERVICE_ID', newCustomerServiceId);
    // 切换会话时需要重新获取conversationId
    let onlyKey = `${state.childChannelId}_${state.groupConversationId}`;
    let conversationId = getCookie(`visitorConversationId_${onlyKey}`);
    if (conversationId) {
      dispatch('updateConversationId', conversationId);
    }

  },
  // 更新和客服对话的id（主要用来判断如果新打开tab页面会话id不会变）
  updateConversationId({
    state,
    commit,
    dispatch
  }, currSessionConversationId) {

    commit('UPDATE_CONVERSATION_ID', currSessionConversationId);
  },
  // 更新当前重连状态
  updateCurrSessionReConnect({
    state,
    commit,
    dispatch
  }, currSessionReConnect) {
    if (currSessionReConnect) {
      // sessionStorage.removeItem('customerServiceId_' + state.childChannelId);
      commit('UPDATE_CUSTOMER_SERVICE_ID', '');

      let onlyKey = `${state.childChannelId}_${state.groupConversationId}`;
      removeCookie(`visitorConversationId_${onlyKey}`);
    }
    commit('UPDATE_CURR_SESSION_RECONNECT', currSessionReConnect);
  },
  // 加载状态
  setLoading({
    state,
    commit,
    dispatch
  }, loadingFlag) {
    commit('UPDATE_LOADING', loadingFlag);
  },
  // 访客事件请求
  setEventLoading({
    state,
    commit,
    dispatch
  }, loadingFlag) {
    commit('UPDATE_EVENT_LOADING', loadingFlag);
  },
  // 隐藏聊天窗口
  closeChatView({
    state,commit
  }) {
    if (state.tell) {
      window.close();
    } else {
      window.parent && window.parent.postMessage && window.parent.postMessage(JSON.stringify({
        type: "chatClose",
        payload: ""
      }), "*");
        if (state.eventLoading) {
            return false
        }
        commit('UPDATE_EVENT_LOADING', true);
        let params = {
            visitSign: state.visitSign,
            oper: 'close',
            message: `&nbsp;[访客]&nbsp;<span style="color: coral">聊窗关闭</span>`
        }
        apiSendEvent(params).then(res => {
          if (res.code === '1') {
              commit('UPDATE_EVENT_LOADING', false);
          }
        })
    }
  },
  // 更新我的名片自定义字段的已超时字段
  updateMyInfoCustomResponseTag({
    state,
    commit,
    dispatch
  }, msg) {
    let nim = state.nim;
    let user = state.myInfo;
    let customs = user.custom ? JSON.parse(user.custom) : {};
    if (customs.responseTag) {
      customs.responseTag = '';
    }
    user.custom = JSON.stringify(customs);
    nim.updateMyInfo({
      ...user,
      done: (error, user) => {
        if (!error) {
          console.log('收到消息访客用户更新成功', user);
          // 发送一条自定义消息触发客服的访客列表信息进行更新
          let msgCustom = {
            type: 4,
            companyId: state.companyId,
            childChannelId: state.childChannelId,
            conversationId: state.currSessionConversationId,
            firstFlg: false,
          }
          console.log('msgCustom', msgCustom);
          nim.sendCustomMsg({
            scene: 'p2p',
            to: state.currSessionId.replace(/^p2p-/, ''),
            custom: JSON.stringify(msgCustom),
            content: JSON.stringify({
              'msg': ''
            }),
            done: (error, msg) => {
              console.log('error', error, msg);
            },
          });
        }
      },
    });
  },
  //获取发送自定义消息参数
  getMsgCustomData({
    state,
    commit,
    dispatch
  }) {
    let firstFlg = true;
    let onlyKey = `${state.childChannelId}_${state.groupConversationId}`
    // let visitorFirstFlagMap = Local.get(`visitorFirstFlagMap_${onlyKey}`);
    // if (visitorFirstFlagMap) {
    //   visitorFirstFlagMap = JSON.parse(visitorFirstFlagMap);
    //   firstFlg = visitorFirstFlagMap[state.currSessionId];
    // }
    let conversationId = getCookie(`visitorConversationId_${onlyKey}`);
    if (conversationId) {
      dispatch('updateConversationId', conversationId);
    }
    let custom = {
      companyId: state.companyId,
      childChannelId: state.childChannelId,
      conversationId: state.currSessionConversationId,
      // firstFlg: firstFlg,
      userId: state.currSessionId.replace(/^p2p-/, ''),
    }
    state.msgCustom = JSON.stringify(custom);
  },
  // 发送重新建立会话后的第一条消息，并且发送成功后访客端不展示，因为已经在建立连接前提前展示了
  sendFirstMsg({
    state,
    commit,
    dispatch
  }, obj) {
    dispatch('getMsgCustomData');
    console.log('state=>>>',state)
    let options = {
      scene: 'p2p', //会话场景（'p2p'：单人聊天，'team'：群聊，'superTeam'：超大群聊天）
      to: state.currSessionId.replace(/^p2p-/, ''),
      custom: state.msgCustom,
      needDelete: true, //这个参数不是发送消息需要的参数，自己做判断用是否需要展示到消息列表
    }
    if (obj.type == 'text') {
      dispatch('sendTextMsg', {
        ...options,
        type: 'text',
        text: obj.value,
      });
    } else {
      if (obj.value) {
        dispatch('sendFileMsg', {
          ...options,
          fileInput: obj.value,
        });
      }
    }
  },
  // 更新会话ID后调取
  onUpdateSiteId({state}, params) {
    const {conversationId, siteId} = params
    apiUpdateSiteId(conversationId, siteId).then(res => {
      if (res.code === 200) {
        console.log(res)
      }
    })
  },
  // 收集错误信息
  collectErrorMessage({
    state,
    commit,
    dispatch
  }, obj) {
    const {from, api, error} = obj;
    if(!error) return
    const secretKey = "yd*0622_message&";
    let params = {
      message: encryptAES(JSON.stringify(obj), secretKey)
    }
    saveCollectErrorMessage(params).then((res) => {
      if (res.code == '1') {
        console.log('成功收集错误信息', res, obj)
      }
    })
  },
  // 收集请求日志
  async collectRequestLog({
    state,
    commit,
    dispatch
  }, obj) {
    let {step, result} = obj;
    const {companyId, childChannelId, globalUnique, originaType, delopType, url} = state;
    // 访问类型
    result +=  "," + originaType;
    // 部署方式
    result +=  "," + delopType;
    // 时间戳
    result += "," + new Date().getTime();
    // 浏览器信息
    result += navigator && navigator.userAgent ? "," + navigator.userAgent : "";

    let params = {
      companyId,
      childChannelId,
      globalUnique,
      step,
      result,
      url
    }
    // 新增指纹参数
    try {
      params.browserFinger = await getBrowserFinger();
    } catch (error) {
      console.error("获取指纹识别 ==>", error)
      params.browserFinger = "";
    }
    // saveRequestLog(params).then((res) => {
    //   if (res.code == '1') {
    //     console.log('成功收集请求日志', res, obj)
    //   }
    // })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/im/actions.js